/**
 * Created by Kieran on 06/05/2017.
 */

import axios from 'axios'
import config from '../../config'


import wrapper from 'axios-cache-plugin';

let postCache = wrapper(axios, {
  maxCacheSize: Infinity,
});


let ListsApi = {

  /**
   * @returns {AxiosPromise}
   */

  getGettingStartedList() {
    return postCache(
      {
        method: 'get',
        url: config.apiUrl + 'list/getting_started/'
      }
    )
  },
  getPreferenceTypes() {
    return axios.get(config.apiUrl + 'list/preference_types/')
  },
  getMoodsList() {
    return axios.get(config.apiUrl + 'list/moods/chunked/')
  },
  getTagList() {
    return axios.get(config.apiUrl + 'list/tags/')
  },
  getInsulinTypesList() {
    return axios.get(config.apiUrl + 'list/insulin_types/')
  },
  getNutritionUnitList() {
    return axios.get(`${config.apiUrl}list/nutrition-units/`)
  },
  getExternalLoginList()
  {
    return axios.get(config.apiUrl + 'list/social-providers')
  }
};

export default ListsApi



// WEBPACK FOOTER //
// ./src/api/Lists/index.js